import React from 'react';
import './About.css';
import Image from '../../assets/avatar-1.jpeg';
import Resume from '../../assets/resume.pdf';
import AboutBox from './AboutBox';
import useScrollReveal from '../../hooks/useScrollReveal';

const About = () => {
    const imgRef  = useScrollReveal(0.1);
    const dataRef = useScrollReveal(0.1);
    const boxRef  = useScrollReveal(0.05);

    const downloadResume = async () => {
        window.open(Resume, '_blank');
    }

    return (
        <section className="about container section" id="about">
            <h2 className="section__title">About Me</h2>

            <div className="about__container grid">
                <img
                    ref={imgRef}
                    src={Image}
                    alt=""
                    className="about__img reveal-left"
                />

                <div ref={dataRef} className="about__data grid reveal-right">
                    <div className="about__info">
                        <p className="about__description">
                            Hello! I'm Abhay Sahgal, currently based in India. I'm a passionate developer and designer who enjoys building impactful digital experiences. I completed my education in Software Engineering and have since been exploring the endless possibilities of mobile app development and UI/UX design.<br /><br />
                            Fast forward to today, and it's been an exciting journey filled with learning, experimentation, and real-world app launches. I've built apps like <strong>Target</strong> (a GATE preparation app) and <strong>Fable</strong> (a professional-level eBook reader with advanced features and a focus on user experience). Each project has helped me grow both technically and creatively.<br /><br />
                            These days, my focus is on building clean, user-centric mobile applications, growing my portfolio with meaningful projects, and continuously improving as both a developer and a designer. <br/>
                            Here are a few technologies I've been working with recently:
                        </p>
                        <ul className="about__list stagger-list">
                            <li>JavaScript (ES6+)</li>
                            <li>TypeScript</li>
                            <li>React</li>
                            <li>Node.js</li>
                            <li>React Native (CLI)</li>
                            <li>NestJS</li>
                            <li>Firebase (Auth, Realtime DB, Firestore)</li>
                            <li>Figma (UI/UX Design)</li>
                        </ul>
                        <button className="contact__button" onClick={downloadResume}>Download CV</button>
                    </div>
                </div>
            </div>

            <div ref={boxRef} className="reveal">
                <AboutBox />
            </div>
        </section>
    )
}

export default About
